// src/components/TransText.js
import React from "react";
import { AnimatePresence, motion } from "framer-motion";

export default function TransText({ text, as: Tag = "span" }) {
  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.span
        key={text}
        initial={{ opacity: 0, y: 4 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -4 }}
        transition={{ duration: 0.18 }}
        style={{ display: "inline-block" }}
      >
        <Tag>{text}</Tag>
      </motion.span>
    </AnimatePresence>
  );
}
